var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgStartsiteCard3 = function SvgStartsiteCard3(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 428,
    viewBox: "0 0 373 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_12263)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 428,
    fill: "#F2EADF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 373,
    height: 428,
    fill: "url(#paint0_linear_1316_12263)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M0 429.5V54.5C0 54.5 119 253 372.5 268.5V429.5H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 157V0H63C140.78 112.041 373 157 373 157Z",
    fill: "#EDE3D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1316_12263",
    x1: 186.5,
    y1: 0,
    x2: 186.5,
    y2: 428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3B996",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B996"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_12263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 428,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgStartsiteCard3);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzczIiBoZWlnaHQ9IjQyOCIgdmlld0JveD0iMCAwIDM3MyA0MjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xMzE2XzEyMjYzKSI+CjxyZWN0IHdpZHRoPSIzNzMiIGhlaWdodD0iNDI4IiBmaWxsPSIjRjJFQURGIi8+CjxyZWN0IG9wYWNpdHk9IjAuMiIgd2lkdGg9IjM3MyIgaGVpZ2h0PSI0MjgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xMzE2XzEyMjYzKSIvPgo8cGF0aCBvcGFjaXR5PSIwLjIyIiBkPSJNMCA0MjkuNVY1NC41QzAgNTQuNSAxMTkgMjUzIDM3Mi41IDI2OC41VjQyOS41SDBaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMzczIDE1N1YwSDYzQzE0MC43OCAxMTIuMDQxIDM3MyAxNTcgMzczIDE1N1oiIGZpbGw9IiNFREUzRDUiLz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzEzMTZfMTIyNjMiIHgxPSIxODYuNSIgeTE9IjAiIHgyPSIxODYuNSIgeTI9IjQyOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRDNCOTk2IiBzdG9wLW9wYWNpdHk9IjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRDNCOTk2Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTMxNl8xMjI2MyI+CjxyZWN0IHdpZHRoPSIzNzMiIGhlaWdodD0iNDI4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";